import { faceImgList, newFaceImgList } from './faceDictionary';
import styles from './faceImgStyle.css';
/**
 * 解析评论中表情
 * @param {String} cmtContent 单条评论内容
 */
const resolveFace = cmtContent => {
    let newContent = cmtContent;

    const reg = /\[([^\]]*)\]/gim;
    const matchList = cmtContent.match(reg);
    const faceList0 = newFaceImgList.map(item => item.title);
    const faceList1 = newFaceImgList.map(item => item.name);
    const faceList2 = faceImgList.map(item => item.name);

    if (matchList) {
        const len = matchList.length;

        for (let i = 0; i < len; i++) {
            const faceStr = matchList[i].replace('[', '').replace(']', '');
            const m = faceList0.indexOf(faceStr);
            const n = faceList1.indexOf(faceStr);
            const k = faceList2.indexOf(faceStr);

            const index = m === -1 ? n : m;

            let html = '';

            if (index > -1) {
                html = `<span class="${styles.face} ${styles[newFaceImgList[index].class]}"></span>`;
            } else if (k > -1) {
                html = `<img src=${faceImgList[k].img} />`;
            }

            newContent = newContent.replace(matchList[i], html);
        }
    }

    return newContent;
};

/**
 * 格式化热评论数据
 * @param {Array} data
 */
export const formatHotListData = data => {
    data.forEach(item => {
        // 解析表情
        const content = item.comment_contents;

        item.contents = resolveFace(content);

        if (item.parent && item.parent.length) {
            item.parent.forEach(itemParent => {
                const pContent = itemParent.comment_contents;

                itemParent.contents = resolveFace(pContent);
            });
        }

        // 根据用户名过滤用户连接
        const uname = item.uname;

        if (uname === '客户端用户' || uname === '手机用户' || uname === '凤凰网友') {
            item.user_url = '';
        }

        // 处理时间
        const plTime = item.comment_date;

        item.year = plTime.substr(0, 4);
        item.date = plTime.substr(5, 2);
        item.time = plTime.substr(8, 8);
    });

    return data;
};
